import { ICommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { TypeUtility } from 'utility-ts-type';
import { APModel, IAPProgram } from '../../../global/models/ap_model';
import { APPreviewPlanServant } from '../../../preferences/components/preview_plan/components/preview_terms_plan_header/servants/ap_preview_plan_servant';
import { IPlanFeebackCourseGroupsDatasource } from '../../../suggestions/components/plan_feedback/datasources/plan_feedback_course_groups_datasource';
import { IPlanFeebackCoursesDatasource } from '../../../suggestions/components/plan_feedback/datasources/plan_feedback_courses_datasource';
import { IPlanFeebackTermsDatasource } from '../../../suggestions/components/plan_feedback/datasources/plan_feedback_terms_datasource';
import { AdvisorCompareQuery } from '../../../suggestions/components/plan_feedback/queries/advisor_compare_query';
import { APAdvisorSentFeedbackTermsQuery } from '../../../suggestions/components/plan_feedback/queries/advisor_sent_feedback_terms_query';
import { APTermsQuery } from '../../queries/ap_terms_query';

export class StudentPlanComparisonController {
  private queries: { feedback: APAdvisorSentFeedbackTermsQuery; terms: AdvisorCompareQuery };
  private models: {
    program: IAPProgram;
  };
  private programTitle: string;
  private creditsTitle: string;
  private studentName: string;
  private estimatedGraduationTime: string;
  constructor(
    private ngAPStudentDetailsQuery: IQuery,
    private ngAPTermsQuery: APTermsQuery,
    private ngAPAdvisorSentFeedbackTermsQuery: APAdvisorSentFeedbackTermsQuery,
    private ngAPAdvisorCompareQuery: AdvisorCompareQuery,
    private loadPlanFeedbackCommand: ICommand,
    private ngPlanFeebackCourseGroupsDatasource: IPlanFeebackCourseGroupsDatasource,
    private ngPlanFeebackCoursesDatasource: IPlanFeebackCoursesDatasource,
    private ngPlanFeebackTermsDatasource: IPlanFeebackTermsDatasource,
    private ngAPModel: APModel,
    private $state: ng.ui.IStateService
  ) {
    this.queries = {
      feedback: this.ngAPAdvisorSentFeedbackTermsQuery,
      terms: this.ngAPAdvisorCompareQuery
    };
    this.models = {
      program: _4.head(_4.toArray(this.ngAPModel.read().program))
    };
  }

  viewHistory() {
    this.$state.go('ap-advisor.changelog');
  }

  $onInit() {
    this.loadPlanFeedbackCommand().then(() => {
      this.ngAPAdvisorCompareQuery.run();
      this.updateLabels();
    });
  }
  updateLabels() {
    this.studentName = _4.upperFirst(this.ngAPStudentDetailsQuery.result.first_name);
    this.programTitle = `${this.models.program.name} ${this.models.program.short_credential}`;
    this.creditsTitle = `| ${TypeUtility.NumberUtility.stripTrailingZeroes(this.models.program.credits)} Credits`;
    this.estimatedGraduationTime = APPreviewPlanServant.getEstimatedGraduationDateFromTerm(
      this.ngAPAdvisorCompareQuery.result
    );
  }
}
angular.module('capability-ng-academic-planner').component('studentPlanComparison', {
  controller: StudentPlanComparisonController,
  templateUrl: 'capability-ng-academic-planner/src/plan/components/student_plan_comparison/student_plan_comparison.html'
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/student_plan_comparison/student_plan_comparison.ts